export const ALBUM_PUBLIC = 'public';
export const ALBUM_XXL = 'xxl';
export const ALBUM_CERTIFIED = 'certified';

export const CERTIFIED_BOBEUR = 'bobeur';
export const CERTIFIED_BOBEUSE = 'bobeuse';

export const ALBUM_LIMITS = {
    [ALBUM_PUBLIC]: 8,
    [ALBUM_CERTIFIED]: 20,
};


// WEBPACK FOOTER //
// ./src/constants/memberPhoto.js